import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsCustomIssueRoute: InvariantJiraRoute = {
	name: 'csm-reports-custom-time-scale-issue',
	path: '/jira/customer-service-management/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
	exact: true,
};
